import { render, staticRenderFns } from "./editor-model-controls.vue?vue&type=template&id=af45bac8&"
import script from "./editor-model-controls.vue?vue&type=script&lang=js&"
export * from "./editor-model-controls.vue?vue&type=script&lang=js&"
import style0 from "./editor-model-controls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports